import { Lightbulb } from "lucide-react";

import { TipsBody } from "./Tips";
import { useTipsRail } from "./TipsRailContext";

/**
 * The section's tips, docked beside the form instead of hidden behind a link.
 * Renders nothing until a section registers something, so the layout can ask it
 * for a column only on the screens that have advice to give.
 */
function TipsRail() {
	const { entries } = useTipsRail();

	if (entries.length === 0) return null;

	return (
		<aside aria-label="Tips" className="rounded-xl border border-gray-200 bg-gray-50 p-4 font-inter">
			<h2 className="mb-3 flex items-center gap-2 font-semibold text-gray-900 text-sm">
				<Lightbulb className="size-4 text-primary-700" />
				Tips
			</h2>
			<div className="flex flex-col gap-5">
				{entries.map(({ id, content }) => (
					<div key={id} className="flex flex-col gap-2 text-gray-700">
						<TipsBody content={content} />
					</div>
				))}
			</div>
		</aside>
	);
}

export default TipsRail;
